<main class="fw-container bg-gray-50">
  <fw-keyword-search-results></fw-keyword-search-results>
  <router-outlet></router-outlet>
  <br />
  <div class="max-w-7xl mx-auto py-16 px-4 sm:py-24 sm:px-6 lg:px-8">
    <ng-adsense></ng-adsense>
  </div>
</main>
<fw-footer></fw-footer>
